import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Box,
  Button,
  Stack,
  Typography,
  useTokens,
} from '@barracuda-internal/bds-core';
import { actions as authActions } from 'guardian/comp/login/authReducer';

const AccountDisabledPage = () => {
  const tokens = useTokens();
  const dispatch = useDispatch();
  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: tokens.aliasesSpaceContainerSpacious,
        textAlign: 'center',
        gap: tokens.aliasesSpaceContainerDefault,
      }}
    >
      <Typography variant="h2">Account not enabled for Prompt Security</Typography>
      <Box sx={{ maxWidth: 500 }}>
        <Typography variant="body1">
          Your account hasn&apos;t been onboarded to Prompt Security yet. Contact
          your administrator to request access.
        </Typography>
      </Box>
      <Button
        bdsType="interactiveEmphasis"
        onClick={() => dispatch(authActions.logout())}
      >
        Sign out
      </Button>
    </Stack>
  );
};

export default AccountDisabledPage;
